import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

export interface MetricData {
  id: number;
  name: string;
  folder_path: string;
  data_type: string;
  value: string;
  timestamp: number;
  metric_properties: PropertyData[];
}

export interface PropertyData {
  id: number;
  name: string;
  data_type: string;
  value: string;
}

@Injectable()
export class RealtimeDataService {
  private dataSubs: { [key: string]: ReplaySubject<MetricData> } = {};

  constructor() {
    this.dataSubs = {};
  }

  /**
   * Find or create subscription for metric with given name
   * @param name Metric Name
   */
  public metricSubject(name: string): ReplaySubject<MetricData> {
    if (!this.dataSubs[name]) {
      this.dataSubs[name] = new ReplaySubject<MetricData>(1);
    }

    return this.dataSubs[name];
  }

  public unsubscribe(): void {
    this.dataSubs = {};
  }

}